// All deposit scheme data tables and rates
// Values exactly as provided in the brochure / problem statement.

export const FD_REGULAR = {
    title: { en: "Fixed Deposit Plan", mr: "मुदत ठेव योजना" },
    terms: {
        en: "Min deposit ₹5,000 and in multiples of ₹5,000. Interest compounded yearly.",
        mr: "किमान ठेव ₹५,००० व त्याच्या पटीत. व्याज वार्षिक चक्रवाढ."
    },
    columns: [
        { label: "12 Months", rate: 9.0, key: "12m" },
        { label: "24 Months", rate: 9.25, key: "24m" },
        { label: "36 Months", rate: 9.5, key: "36m" },
        { label: "60 Months", rate: 9.75, key: "60m" }
    ],
    rows: [
        { amount: 10000, "12m": 10900, "24m": 11850, "36m": 12850, "60m": 14875 },
        { amount: 20000, "12m": 21800, "24m": 23700, "36m": 25700, "60m": 29750 },
        { amount: 50000, "12m": 54500, "24m": 59250, "36m": 64250, "60m": 74375 },
        { amount: 100000, "12m": 109000, "24m": 118500, "36m": 128500, "60m": 148750 },
        { amount: 200000, "12m": 218000, "24m": 237000, "36m": 257000, "60m": 297500 },
        { amount: 500000, "12m": 545000, "24m": 592500, "36m": 642500, "60m": 743750 }
    ],
    premature: {
        en: [
            "12 Month FD: No premature withdrawal",
            "24 Month FD: No withdrawal before 12 months; 13–18 months: 5.5% PA",
            "36 Month FD: No withdrawal before 12 months; 19–30 months: 5.5% PA; after 30 months: 6% PA",
            "60 Month FD: No withdrawal before 36 months; 37–54 months: 6% PA"
        ],
        mr: [
            "१२ महिन्यांची एफडी: अकाली पैसे काढण्याची सुविधा नाही",
            "२४ महिन्यांची एफडी: १२ महिन्यांपूर्वी पैसे काढता येणार नाहीत; १३–१८ महिने: ५.५% वार्षिक",
            "३६ महिन्यांची एफडी: १२ महिन्यांपूर्वी काढता येणार नाहीत; १९–३० महिने: ५.५% वार्षिक; ३० महिन्यांनंतर: ६% वार्षिक",
            "६० महिन्यांची एफडी: ३६ महिन्यांपूर्वी काढता येणार नाहीत; ३७–५४ महिने: ६% वार्षिक"
        ]
    }
};

export const FD_SENIOR = {
    title: { en: "Fixed Deposit Plan – Above 60 Years", mr: "मुदत ठेव – ज्येष्ठ नागरिक (६० वर्षांवरील)" },
    terms: {
        en: "Senior citizens get 0.25% additional rate on FD plans. Min ₹5,000.",
        mr: "ज्येष्ठ नागरिकांना मुदत ठेवीवर ०.२५% अतिरिक्त व्याज. किमान ₹५,०००."
    },
    columns: [
        { label: "12 Months", rate: 9.25, key: "12m" },
        { label: "24 Months", rate: 9.5, key: "24m" },
        { label: "36 Months", rate: 9.75, key: "36m" },
        { label: "60 Months", rate: 10.0, key: "60m" }
    ],
    rows: [
        { amount: 10000, "12m": 10925, "24m": 11900, "36m": 12925, "60m": 15000 },
        { amount: 20000, "12m": 21850, "24m": 23800, "36m": 25850, "60m": 30000 },
        { amount: 50000, "12m": 54625, "24m": 59500, "36m": 64625, "60m": 75000 },
        { amount: 100000, "12m": 109250, "24m": 119000, "36m": 129250, "60m": 150000 },
        { amount: 200000, "12m": 218500, "24m": 238000, "36m": 258500, "60m": 300000 },
        { amount: 500000, "12m": 546250, "24m": 595000, "36m": 646250, "60m": 750000 }
    ]
};

export const MIP_REGULAR = {
    title: { en: "Monthly Income Plan", mr: "मासिक उत्पन्न योजना" },
    terms: {
        en: "Min MIP ₹10,000 and in multiples of ₹10,000. First income paid after 30 days.",
        mr: "किमान एमआयपी ₹१०,००० व त्याच्या पटीत. पहिले उत्पन्न ३० दिवसांनंतर."
    },
    columns: [
        { label: "12 Months", rate: 8.0, key: "12m" },
        { label: "24 Months", rate: 8.25, key: "24m" },
        { label: "36 Months", rate: 8.5, key: "36m" },
        { label: "60 Months", rate: 8.75, key: "60m" }
    ],
    rows: [
        { amount: 50000, "12m": 331, "24m": 341, "36m": 352, "60m": 362 },
        { amount: 100000, "12m": 662, "24m": 683, "36m": 703, "60m": 724 },
        { amount: 200000, "12m": 1325, "24m": 1366, "36m": 1407, "60m": 1448 },
        { amount: 300000, "12m": 1987, "24m": 2048, "36m": 2110, "60m": 2172 },
        { amount: 500000, "12m": 3311, "24m": 3414, "36m": 3517, "60m": 3620 },
        { amount: 1000000, "12m": 6623, "24m": 6828, "36m": 7034, "60m": 7239 }
    ],
    premature: {
        en: [
            "12 Month: No premature withdrawal",
            "24 Month: No withdrawal before 12 months; 13–18 months: 5% PA",
            "36 Month: No withdrawal before 18 months; 19–30 months: 5% PA; after 30 months: 5.5% PA"
        ],
        mr: [
            "१२ महिने: अकाली काढता येणार नाहीत",
            "२४ महिने: १२ महिन्यांपूर्वी काढता येणार नाहीत; १३–१८ महिने: ५% वार्षिक",
            "३६ महिने: १८ महिन्यांपूर्वी काढता येणार नाहीत; १९–३० महिने: ५% वार्षिक; ३० महिन्यांनंतर: ५.५% वार्षिक"
        ]
    }
};

export const MIP_SENIOR = {
    title: { en: "Monthly Income Plan – Above 60 Years", mr: "मासिक उत्पन्न – ज्येष्ठ नागरिक" },
    terms: {
        en: "Senior citizens receive higher monthly income. Min ₹10,000.",
        mr: "ज्येष्ठ नागरिकांना अधिक मासिक उत्पन्न. किमान ₹१०,०००."
    },
    columns: [
        { label: "12 Months", rate: 8.25, key: "12m" },
        { label: "24 Months", rate: 8.5, key: "24m" },
        { label: "36 Months", rate: 8.75, key: "36m" },
        { label: "60 Months", rate: 9.0, key: "60m" }
    ],
    rows: [
        { amount: 50000, "12m": 341, "24m": 352, "36m": 362, "60m": 372 },
        { amount: 100000, "12m": 683, "24m": 702, "36m": 724, "60m": 744 },
        { amount: 200000, "12m": 1366, "24m": 1407, "36m": 1448, "60m": 1489 },
        { amount: 300000, "12m": 2048, "24m": 2110, "36m": 2172, "60m": 2233 },
        { amount: 500000, "12m": 3414, "24m": 3517, "36m": 3620, "60m": 3722 },
        { amount: 1000000, "12m": 6828, "24m": 7034, "36m": 7239, "60m": 7444 }
    ]
};

export const RD_PLAN = {
    title: { en: "Recurring Deposit Plan", mr: "आवर्ती ठेव योजना" },
    terms: {
        en: "Monthly deposits with attractive interest. Build a lump sum systematically.",
        mr: "मासिक ठेवींवर आकर्षक व्याज. नियमित बचतीतून मोठी रक्कम तयार करा."
    },
    columns: [
        { label: "12 Months · 10%", key: "12m" },
        { label: "24 Months · 10.5%", key: "24m" },
        { label: "36 Months · 11%", key: "36m" },
        { label: "60 Months · 11.5%", key: "60m" }
    ],
    rates: { "12m": 10.0, "24m": 10.5, "36m": 11.0, "60m": 11.5 },
    // Each cell: { deposit, value }
    rows: [
        { monthly: 500,  "12m": { deposit: 6000, value: 6332 },   "24m": { deposit: 12000, value: 13392 },  "36m": { deposit: 18000, value: 21372 },  "60m": { deposit: 30000, value: 40557 } },
        { monthly: 1000, "12m": { deposit: 12000, value: 12665 }, "24m": { deposit: 24000, value: 26784 },  "36m": { deposit: 36000, value: 42744 },  "60m": { deposit: 60000, value: 81115 } },
        { monthly: 2000, "12m": { deposit: 24000, value: 25329 }, "24m": { deposit: 48000, value: 53568 },  "36m": { deposit: 72000, value: 85487 },  "60m": { deposit: 120000, value: 162229 } },
        { monthly: 3000, "12m": { deposit: 36000, value: 37994 }, "24m": { deposit: 72000, value: 80352 },  "36m": { deposit: 108000, value: 128231 }, "60m": { deposit: 180000, value: 243344 } },
        { monthly: 5000, "12m": { deposit: 60000, value: 63323 }, "24m": { deposit: 120000, value: 133920 }, "36m": { deposit: 180000, value: 213718 }, "60m": { deposit: 300000, value: 405573 } }
    ]
};

export const BAL_VIKAS = {
    title: { en: "Bal Vikas Thev (5 Year Monthly)", mr: "बालविकास ठेव (५ वर्षे मासिक)" },
    rows: [
        { monthly: 335, maturity: 25000 },
        { monthly: 650, maturity: 50000 },
        { monthly: 975, maturity: 75000 },
        { monthly: 1300, maturity: 100000 }
    ]
};

export const DAILY_SAVINGS = {
    title: { en: "Daily Savings Thev · 7% PA", mr: "दैनिक ठेव · ७% वार्षिक" },
    rows: [
        { daily: 100, y1: 37900, y2: 79380, y3: 125940, loan: 75000 },
        { daily: 200, y1: 75800, y2: 158760, y3: 251880, loan: 150000 },
        { daily: 300, y1: 113700, y2: 238060, y3: 377930, loan: 250000 }
    ]
};

export const SHORT_TERM_FD = {
    title: { en: "Short Term Fixed Deposit (Mudat Thev)", mr: "अल्पमुदत ठेव (मुदत ठेव)" },
    rows: [
        { period: { en: "30 – 90 days", mr: "३० – ९० दिवस" }, rate: "5.00%" },
        { period: { en: "91 – 180 days", mr: "९१ – १८० दिवस" }, rate: "6.00%" },
        { period: { en: "181 days – 1 year", mr: "१८१ दिवस – १ वर्ष" }, rate: "7.00%" },
        { period: { en: "1 – 2 years", mr: "१ – २ वर्षे" }, rate: "9.50%" },
        { period: { en: "Above 3 years", mr: "३ वर्षांपेक्षा अधिक" }, rate: "10.00%" }
    ]
};

export const SPECIAL_SCHEMES = [
    {
        icon: "fa-arrow-trend-up",
        title: { en: "FD – Double in 84 Months", mr: "मुदत ठेव – ८४ महिन्यांत दुप्पट" },
        desc: { en: "Deposit today and double your money in just 84 months.", mr: "आज ठेव ठेवा आणि केवळ ८४ महिन्यांत पैसे दुप्पट करा." }
    },
    {
        icon: "fa-coins",
        title: { en: "FD – 1.5× in 50 Months", mr: "मुदत ठेव – ५० महिन्यांत दीडपट" },
        desc: { en: "Grow your deposit 1.5 times in 50 months.", mr: "५० महिन्यांत आपली ठेव दीडपट वाढवा." }
    },
    {
        icon: "fa-medal",
        title: { en: "Lakhpati Yojana (₹1,00,000)", mr: "लखपती योजना (₹१,००,०००)" },
        desc: {
            en: "RD ₹2,000/month for 42 months → ₹1,00,000. Or ₹1,000/month for 72 months → ₹1,00,000.",
            mr: "₹२,०००/महिना × ४२ महिने → ₹१,००,०००. किंवा ₹१,०००/महिना × ७२ महिने → ₹१,००,०००."
        }
    },
    {
        icon: "fa-calendar-week",
        title: { en: "RD ₹500 × 168 Weeks = Double", mr: "आवर्ती ठेव ₹५०० × १६८ आठवडे = दुप्पट" },
        desc: { en: "Save ₹500 weekly for 168 weeks to double your deposit.", mr: "१६८ आठवडे दर आठवड्याला ₹५०० ठेवा आणि ठेव दुप्पट करा." }
    },
    {
        icon: "fa-child",
        title: { en: "Samrudhi Thev Yojana", mr: "समृद्धी ठेव योजना" },
        desc: { en: "Accumulate ₹1,00,000 by your child's 18th birthday with planned monthly deposits.", mr: "नियोजित मासिक ठेवीद्वारे मुलाच्या १८ व्या वाढदिवसापर्यंत ₹१,००,००० जमा करा." }
    },
    {
        icon: "fa-seedling",
        title: { en: "Bal Vikas Thev (5 Year)", mr: "बालविकास ठेव (५ वर्षे)" },
        desc: { en: "From ₹335/month to ₹1,300/month → secure your child's future.", mr: "₹३३५/महिना ते ₹१,३००/महिना → मुलांचे भविष्य सुरक्षित करा." }
    }
];

// Helper: nicely format INR amount
export const fmtINR = (n) => {
    if (n === null || n === undefined || isNaN(n)) return "—";
    return new Intl.NumberFormat("en-IN", { maximumFractionDigits: 0 }).format(Math.round(n));
};
